// extracted by mini-css-extract-plugin
export default {"energyItem":"energy-item_energyItem__rSpFC"};